import { render, staticRenderFns } from "./TCDCResourceCenter.vue?vue&type=template&id=045384f5"
import script from "./TCDCResourceCenter.vue?vue&type=script&lang=js"
export * from "./TCDCResourceCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports